import React from 'react';
import Button from './Button';
var NavButtons = function (_a) {
    var navButtons = _a.navButtons, handleSegmentEvents = _a.handleSegmentEvents;
    return (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-4" }, navButtons.map(function (buttonData, index) { return (React.createElement(Button, { buttonData: buttonData, isLastMenuItem: (navButtons === null || navButtons === void 0 ? void 0 : navButtons.length) - 1 === index, key: index, handleSegmentEvents: handleSegmentEvents })); })));
};
export default NavButtons;
//# sourceMappingURL=index.js.map